import React, { ReactNode } from "react"
import Typography from "@/components/Typography"
import Box from "@/components/Box"

type DropDownMenuProps = {
  title: string
  content?: ReactNode
}

export const DropDownMenu = ({ title, content }: DropDownMenuProps) => {
  return (
    <Box
      maxHeight={460}
      width={374}
      overflowY="scroll"
      p={4}
      position="absolute"
      right={0}
      zIndex={999}
      top={7}
      backgroundColor={"backgroundLight"}
      border={"2px solid #9EA1A2"}
      borderRadius={"8px"}
    >
      <Typography
        variant="h7"
        leadingTrim
        color={"primaryBrightBlueLightBg"}
        pl={4}
        mb={3}
      >
        {title}
      </Typography>
      {content}
    </Box>
  )
}
